import { defineStore } from "pinia";

export const useEvaluationMeasureStore = defineStore('evaluationMeasure', {
    state: () => ({
        evaluationMeasure: {},
        evaluationMeasures: [],
    }),
    actions: {
        setEvaluationMeasure(evaluationMeasure) {
            this.evaluationMeasure = evaluationMeasure
        },
        setEvaluationMeasures(evaluationMeasures) {
            this.evaluationMeasures = evaluationMeasures
        },
        addEvaluationMeasure(evaluationMeasure) {
            this.evaluationMeasures.unshift(evaluationMeasure)
        },
        updateEvaluationMeasure(evaluationMeasure) {
            let index = this.evaluationMeasures.findIndex(cl => cl.id === evaluationMeasure.id)
            this.evaluationMeasures.splice(index, 1, evaluationMeasure)
        },
        deleteEvaluationMeasure(evaluationMeasure) {
            let index = this.evaluationMeasures.findIndex(cl => cl.id === evaluationMeasure.id)
            this.evaluationMeasures.splice(index, 1)
        },
    },
});